'use strict';

require('./components/rolexV7StoreLocatorMap').init();
require('./components/rolexStoreLocatorMapCpo').init();
require('./components/rolexV7StoreDetailsMap').init();
require('./components/rolexStoreDetailsMapCpo').init();
